const INVISIBLE_EMAIL_CHARACTERS = /[\u200B-\u200D\u2060\uFEFF]/g;

export function normalizeEmailInput(value: string) {
  return String(value ?? "")
    .normalize("NFKC")
    .replace(INVISIBLE_EMAIL_CHARACTERS, "")
    .trim()
    .toLowerCase();
}
